
export default {
  name: 'PlaceholderMap'
}
